module.exports = __webpack_public_path__ + "static/media/addIcon.4088e0ab.svg";